import React from "react";
import { WidgetInputCheckboxList, WidgetInputProps } from "../../types";
import { WidgetInputLabel } from "@fidget/common/components/chat/widgetInputLabel/widgetInputLabel";
import styles from "../styles.css";
import { WidgetCheckboxInput } from "@fidget/common/components/inputs/widgetCheckboxInput/widgetCheckboxInput";

interface Props extends WidgetInputProps {
  input: WidgetInputCheckboxList;
}

export const CheckboxListInput = ({ input, formId, isSubmitted, onChange, userAnswers }: Props) => {
  const handleChecked = (checked: boolean, value: string) => {
    const currentValues = userAnswers[input.name]?.values || [];
    if (checked) {
      onChange({ inputName: input.name, values: [...currentValues, value] });
    } else {
      onChange({ inputName: input.name, values: currentValues.filter((v) => v !== value) });
    }
  };

  return (
    <div>
      <WidgetInputLabel text={input.displayName} />
      <div className={styles["options-checkboxes"]}>
        {input.options.map((o) => (
          <WidgetCheckboxInput
            key={o.value}
            id={formId + o.value}
            onChange={(checked) => handleChecked(checked, o.value)}
            checked={!!userAnswers[input.name]!.values?.find((v) => v === o.value)}
            label={o.displayName}
            colorSchema="primary"
            disabled={isSubmitted}
          />
        ))}
      </div>
    </div>
  );
};
